import type {
  TCreateMajorAction,
  TSubmitMajorActionResponse,
} from '@kapitalist/contract/endpoints'
import {endpoints} from '@kapitalist/contract/endpoints'
import type {TFormError, TGameId} from '@kapitalist/contract/types'
import {PostApi} from '~/api/client'
import {transformGameData} from '~/api/endpoints/game/GetGameData'
import {gameDataMockAtTime} from '~/api/endpoints/game/GetGameData/mock'
import MockConfig from '~/api/mocks/config'

const endpoint = endpoints.gameplay.submitMajorAction

/**
 * "Take a turn"
 */
export default class SubmitMajorAction extends PostApi<typeof endpoint>() {
  constructor() {
    super(endpoint)
  }

  protected mockRequestFailure(
    params: TCreateMajorAction,
    pathPieces: {gameId: TGameId}
  ): TFormError | null {
    if (pathPieces.gameId === 'fail') {
      return {errors: {gameId: [`That game doesn't exist.`]}}
    }

    // return super.mockRequestFailure(params, pathPieces)
    return null // TODO replace this with defaultMockRequestFailure if/once we bring that behavior in from MW
  }

  protected getMockResponse(): TSubmitMajorActionResponse {
    return {
      gameData: gameDataMockAtTime(++MockConfig.time),
    }
  }

  protected transformResponse(r: TSubmitMajorActionResponse) {
    return {
      ...r,
      gameData: transformGameData(r.gameData),
    }
  }
}
